import * as angular from "angular";
import {IController} from "angular";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class BillingAccountsTableCtrl implements IController{
  queryString: String;

  private billingAccountsRef: any;
  private loadLimit = 30;
  public infiniteScroll: any;
  public isScrollable: any;

  /* @ngInject */
  constructor(private $infiniteScroll, private $billingAccounts,  private $log, private commonsAlertsService: CommonsAlertsService, private $mdMedia){
  }

  $onInit() {
    this.billingAccountsRef = this.$billingAccounts();
    this.billingAccountsRef.$query(this._getBillingAccountsQuery());
    this.infiniteScroll = this.$infiniteScroll(this.billingAccountsRef, this.loadLimit, {getFullData: true});
  };

  $onChanges(changes) {
    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this._loadBillingAccounts();
    }
  };

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-md');
  };

  /////////////////////////////////////////////////////////////////////

  // ******************************
  //        Private methods
  // ******************************
  //
  _loadBillingAccounts() {
    this.billingAccountsRef.$query(this._getBillingAccountsQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to load billing accounts ', error);
      })
  }
  //
  _getBillingAccountsQuery() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
    }
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountsTable', {
    bindings: {
      queryString: '<?',
    },
    template: require('./billing-accounts-table.html').default,
    controller: BillingAccountsTableCtrl
  });
